import React, { useState, useEffect } from "react";
import "./Hero.css";
import WaitlistModal from "./WaitlistModal";
import "./WaitlistModal.css";
import CMS from "../cms.json";
import GENERATED_HERO_SLIDES_DATA from "../generatedHeroSlidesData";

const heroSection = CMS["hero-section"] || {};
const stripImages = GENERATED_HERO_SLIDES_DATA.stripImages || [];
const slideImages = GENERATED_HERO_SLIDES_DATA.slideImages || [];

const SLIDE_DURATION = 6000;

const YOUTUBE_EMBED = heroSection.videoEmbed ||
  "https://www.youtube.com/embed/Nimq2nMMMdw?autoplay=1&mute=1&loop=1&playlist=Nimq2nMMMdw&controls=1&modestbranding=1&rel=0";

const grainTexture = heroSection.grainTexture || "/images/grain.webp";
const navLinks = heroSection.navLinks || [];

const socials = CMS.socials || {};
const socialIcons = socials.icons || {};
const heroSocials = [
  { key: "tiktok",    alt: "TikTok" },
  { key: "instagram", alt: "Instagram" },
  { key: "youtube",   alt: "YouTube" },
].filter(s => socials[s.key] && socialIcons[s.key]);

const GrainLayer = () => (
  <div
    aria-hidden="true"
    style={{
      position: "absolute", inset: 0,
      backgroundImage: `url(${grainTexture})`,
      backgroundRepeat: "repeat",
      backgroundSize: "600px 600px",
      pointerEvents: "none",
      zIndex: 3,
      opacity: 0.3,
      mixBlendMode: "screen",
    }}
  />
);

const Hero = () => {
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const [isModalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    if (window.location.hash === "#join-waitlist") setModalOpen(true);
  }, []);

  useEffect(() => {
    if (slideImages.length === 0) return;
    const si = setInterval(
      () => setCurrentSlideIndex((i) => (i + 1) % slideImages.length),
      SLIDE_DURATION
    );
    return () => clearInterval(si);
  }, []);

  const handleNav = (e, href) => {
    if (!href.startsWith("#")) return;
    e.preventDefault();
    const el = document.getElementById(href.slice(1));
    if (el) el.scrollIntoView({ behavior: "smooth" });
    else window.location.hash = href;
  };

  return (
    <>
      {/* ── SLATE: full-viewport title ── */}
      <section className="hero-title-slate">
        <GrainLayer />

        {/* social links top-left only */}
        <div className="hero-inline-nav">
          <div className="social-links">
            {heroSocials.map(s => (
              <a key={s.key} href={socials[s.key]} target="_blank" rel="noreferrer">
                <img src={socialIcons[s.key]} alt={s.alt} />
              </a>
            ))}
          </div>
        </div>

        {/* centered title */}
        <div className="hero-title-content">
          <p className="hero-eyebrow">{heroSection.eyebrow || "Est. Prague · Cinematic Rock"}</p>
          <h1 className="hero-main-title">{heroSection.title || "Welcome to The Creaks Show"}</h1>
          <p className="hero-subheadline">{heroSection.subline}</p>

          <nav className="hero-slate-nav">
            {navLinks.map((nl) => (
              <a
                key={nl.label}
                className="hero-slate-nav-link"
                href={nl.href}
                target={nl.external ? "_blank" : undefined}
                rel={nl.external ? "noreferrer" : undefined}
                onClick={nl.href.startsWith("#") ? (e) => handleNav(e, nl.href) : undefined}
              >
                {nl.label}
              </a>
            ))}
          </nav>
        </div>

        {/* film strip — duplicated for seamless loop */}
        <div className="hero-film-strip" aria-hidden="true">
          <div className="hero-film-track">
            {[...stripImages, ...stripImages].map((src, i) => (
              <img key={i} src={src} alt="" className="hero-film-img" />
            ))}
          </div>
        </div>
      </section>

      {/* ── VISUAL: square video + photo strip ── */}
      <section className="hero-visual-section">
        <GrainLayer />

        <div className="hero-video-col">
          <iframe
            src={YOUTUBE_EMBED}
            title="The Creaks — Never Landing (Official Music Video)"
            allow="autoplay; encrypted-media"
            allowFullScreen
          />
        </div>

        <div className="hero-photo-col">
          {slideImages.length > 0 ? (
            slideImages.map((src, index) => (
              <div key={index} className={`slide ${index === currentSlideIndex ? "active" : ""}`}>
                <img src={src} alt="" className="slide-image" />
              </div>
            ))
          ) : (
            <div style={{ width: "100%", height: "100%", background: "#0a0a0a" }} />
          )}
          <span className="hero-ballet-watermark" aria-hidden="true">The Creaks</span>
        </div>
      </section>

      <WaitlistModal show={isModalOpen} onClose={() => setModalOpen(false)} />
    </>
  );
};

export default Hero;
